import { CacheKey } from '@auth0/auth0-spa-js';
var cacheKeyPrefix = '@@auth0spajs@@';
export var createCacheKey = function (e) {
    var cacheKey = new CacheKey(e);
    return cacheKey.toKey();
};
export var getCacheValue = function (key) {
    return localStorage.getItem(createCacheKey(key));
};
export var clearAllCacheValues = function () {
    return Object.keys(localStorage)
        .filter(function (a) { return a.startsWith(cacheKeyPrefix); })
        .forEach(function (a) { return localStorage.removeItem(a); });
};
//# sourceMappingURL=Cache.js.map